import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import TargetIcon from 'react-icons/lib/fa/location-arrow';
import Modali, { useModali } from 'modali';

import './CoordinatesInput.scss';

const LazyMapInput = React.lazy(() => import('./LazyMapInput'));

const CoordinatesInput = ({
  latitude, longitude, change, address,
}) => {
  const [showMapModal, toggleMapModal] = useModali({
    title: 'Modify Lat/Long Coordinates',
    animated: true,
    centered: true,
    large: true,
  });

  return (
    <div>
      <button
        type="button"
        className="btn anow__btn"
        onClick={() => {
          toggleMapModal();
        }}
      >
        Modify Lat/Long Coordinates
        <TargetIcon className="ml-10" size={18} />
      </button>
      <Modali.Modal {...showMapModal}>
        <Suspense fallback={<div>Loading...</div>}>
          <LazyMapInput
            address={address}
            change={change}
            toggleModal={toggleMapModal}
            latitude={latitude}
            longitude={longitude}
          />
        </Suspense>
      </Modali.Modal>
    </div>
  );
};

CoordinatesInput.propTypes = {
  latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  change: PropTypes.func.isRequired,
  address: PropTypes.objectOf(PropTypes.string),
};
CoordinatesInput.defaultProps = {
  latitude: null,
  longitude: null,
  address: null,
};

export default CoordinatesInput;
